<template>
  <v-menu
    v-model="showMenu"
    auto
    min-width="400"
    :close-on-content-click="false"
  >
    <template #activator="{ props }">
      <slot :props="props" />
    </template>
    <v-card>
      <v-card-text>
        <v-card-subtitle class="pa-0 pb-1 d-flex align-center justify-space-between">
          <span>Phone number</span>
          <v-btn
            variant="text"
            icon
            size="small"
            @click="showMenu = false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-subtitle>
        <div class="d-flex align-center">
          <v-autocomplete
            v-model="countryCode"
            style="max-width: 90px"
            class="mr-1"
            item-title="name"
            item-value="iso"
            :items="countriesList"
            hide-details
          >
            <template #item="{ item, props: itemProps }">
              <v-list-item v-bind="itemProps" :title="undefined">
                <div class="d-flex align-center">
                  <v-img
                    height="22"
                    width="36"
                    :src="item.raw.flagUrl"
                    class="mr-1"
                  />
                  <span>{{ item.raw.iso }}</span>
                </div>
              </v-list-item>
            </template>
            <template #selection="{ item }">
              <v-img
                height="16"
                width="27"
                :src="item.raw.flagUrl"
                class="mr-1"
              />
            </template>
          </v-autocomplete>
          <v-text-field
            v-model="phone"
            v-facade="phoneMask"
            top
            autofocus
            hide-details
          />
          <v-text-field
            v-if="showExtension"
            v-model="extension"
            label="Extension"
            style="max-width: 105px"
            class="ml-2"
            hide-details
          />
        </div>
        <div class="d-flex align-center mt-2 gap-2">
          <v-spacer />
          <v-btn height="30" variant="outlined" @click="showMenu = false">Cancel</v-btn>
          <v-btn height="30" color="primary" @click="savePhone">
            Save
          </v-btn>
        </div>
      </v-card-text>
    </v-card>
  </v-menu>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

import { getCountryMask } from '@/bundles/Common/helpers/getCountries';
import { CountriesMasksMixin } from '@/bundles/Common/mixins/CountriesMasksMixin';
import { getAccountCountry } from '@/bundles/Companies/helpers/companyDefaultData';

interface ICommonPhonePicker {
  showMenu: boolean;
  phone: string;
  extension: string;
  countryCode: string;
  phoneMask: string;
}

export default defineComponent({
  name: 'CommonPhonePicker',
  mixins: [CountriesMasksMixin],

  props: {
    phoneCountryCode: {
      type: String,
      default: ''
    },
    phoneNumber: {
      type: String,
      default: ''
    },
    phoneExtension: {
      type: String,
      default: ''
    },
    showExtension: Boolean
  },

  emits: ['save:countryCode', 'save:extension', 'save:number'],

  data: (): ICommonPhonePicker => ({
    showMenu: false,
    phone: '',
    extension: '',
    countryCode: getAccountCountry(),
    phoneMask: getCountryMask([], getAccountCountry())
  }),

  watch: {
    showMenu () {
      this.phone = this.phoneNumber;
      this.extension = this.phoneExtension;
      this.countryCode = this.phoneCountryCode || getAccountCountry();
    },
    countryCode (value) {
      if (!value) {
        this.countryCode = getAccountCountry();
      }

      this.setMaskForCountry();
    }
  },

  methods: {
    savePhone () {
      this.$emit('save:number', this.phone);
      this.$emit('save:countryCode', this.countryCode);

      if (this.showExtension) {
        this.$emit('save:extension', this.extension);
        this.extension = '';
      }

      this.showMenu = false;
      this.phone = '';
    },
    setMaskForCountry () {
      this.phoneMask = getCountryMask(this.countriesList, this.countryCode);
    },
  }
});
</script>
